import { render } from "./certificate-10.vue?vue&type=template&id=12069b45&scoped=true"
import script from "./certificate-10.vue?vue&type=script&lang=js"
export * from "./certificate-10.vue?vue&type=script&lang=js"

import "./certificate-10.vue?vue&type=style&index=0&id=12069b45&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12069b45"]])

export default __exports__